module.exports = __webpack_public_path__ + "static/media/3@3x.39d42788.png";